import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_productcategory,
  add_productcategory,
  update_productcategory,
  delete_productcategory,
  get_productcategory_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  productcategory: [],
  productcategorylist: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    category_name: "",
    category_image: ""
  },
};

// Async Thunks for API Calls
export const fetchproductcategorylist = createAsyncThunk(
  'productcategory/fetchproductcategorylist',
  async ({ school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_productcategory_list(school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



// Async Thunks for API Calls
export const fetchproductcategory = createAsyncThunk(
  "productcategory/fetchproductcategory",
  async ({ page, page_size, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_productcategory(page, page_size, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createproductcategory = createAsyncThunk(
  "productcategory/createproductcategory",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_productcategory(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateproductcategory = createAsyncThunk(
  "productcategory/updateproductcategory",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_productcategory(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const deleteproductcategory = createAsyncThunk(
  "productcategory/deleteproductcategory",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_productcategory({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// hostel_category Slice
const productcategorySlice = createSlice({
  name: 'productcategorys',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, category_name } = action.payload;
      state.formData = { id, category_name };
    },
    resetFormData(state) {
      state.formData = {
        category_name: "",
        category_image: ""
      };
    },
    setproductcategory(state, action) {
      state.productcategory = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchproductcategorylist.fulfilled, (state, action) => {
        state.productcategorylist = action.payload.data;
      })
      .addCase(fetchproductcategorylist.rejected, (state, action) => {
        state.productcategorylist = [];
      })

      // Fetch hostel_category
      .addCase(fetchproductcategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchproductcategory.fulfilled, (state, action) => {
        state.loading = false;
        state.productcategory = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchproductcategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add hostel_category
      .addCase(createproductcategory.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createproductcategory.fulfilled, (state, action) => {
        state.addLoading = false;
        state.productcategory = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createproductcategory.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update hostel_category
      .addCase(updateproductcategory.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateproductcategory.fulfilled, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      .addCase(updateproductcategory.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete hostel_category
      .addCase(deleteproductcategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteproductcategory.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteproductcategory.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const { setproductcategory,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = productcategorySlice.actions;
export default productcategorySlice.reducer;
